import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  StatusRole,
} from "../../../../../../features/admin/role_permmission/role/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.usermanagement.roles);
  // const all_country = useSelector((state) => state.common.all_country);

  const [name, setName] = useState("");
  const [onPageChange, setonPageChange] = useState(1);

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = 1) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  // console.log(all_country);

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(StatusRole(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    name,
    setName,
    fetch,
    setonPageChange,
    deleteData,
    toggleStatus,
    country,
  };
};
